import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ClothingMarker,
  ClothingMatrixCell,
  ClothingMatrixRow
} from '../../../models/clothing.model';

export interface ClothingMatrixAction {
  row: ClothingMatrixRow;
  cell: ClothingMatrixCell;
}

@Component({
  selector: 'app-clothing-admin-matrix',
  templateUrl: './clothing-admin-matrix.component.html',
  styleUrls: ['./clothing-admin-matrix.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClothingAdminMatrixComponent {
  @Input() hideHeader = false;
  @Input() markers: ClothingMarker[] = [];
  @Input() rows: ClothingMatrixRow[] = [];
  @Input() editingCellKey = '';
  @Input() editingCellValue = 0;
  @Input() savingCellKey = '';
  @Input() isLoading = false;
  @Output() editingCellValueChange = new EventEmitter<number>();
  @Output() createCatalog = new EventEmitter<void>();
  @Output() createMarker = new EventEmitter<void>();
  @Output() editCatalog = new EventEmitter<string>();
  @Output() startEdit = new EventEmitter<ClothingMatrixAction>();
  @Output() saveEdit = new EventEmitter<ClothingMatrixAction>();
  @Output() cancelEdit = new EventEmitter<void>();

  get hasMarkers(): boolean {
    return this.markers.length > 0;
  }

  get hasRows(): boolean {
    return this.rows.length > 0;
  }

  openCreateCatalog() {
    this.createCatalog.emit();
  }

  openCreateMarker() {
    this.createMarker.emit();
  }

  openEditCatalog(itemId: string) {
    this.editCatalog.emit(itemId);
  }

  updateEditingCellValue(value: number) {
    this.editingCellValueChange.emit(Number(value));
  }

  requestStartEdit(row: ClothingMatrixRow, cell: ClothingMatrixCell) {
    this.startEdit.emit(this.createAction(row, cell));
  }

  requestSave(row: ClothingMatrixRow, cell: ClothingMatrixCell) {
    this.saveEdit.emit(this.createAction(row, cell));
  }

  requestCancel() {
    this.cancelEdit.emit();
  }

  isEditingCell(row: ClothingMatrixRow, cell: ClothingMatrixCell): boolean {
    return this.editingCellKey === this.createCellKey(row.item.id, cell.key);
  }

  isSavingCell(row: ClothingMatrixRow, cell: ClothingMatrixCell): boolean {
    return this.savingCellKey === this.createCellKey(row.item.id, cell.key);
  }

  trackByMarker(index: number, marker: ClothingMarker): string {
    return marker.markerType + '::' + marker.markerCode;
  }

  trackByRow(index: number, row: ClothingMatrixRow): string {
    return row.item.id;
  }

  trackByCell(index: number, cell: ClothingMatrixCell): string {
    return cell.key;
  }

  private createAction(
    row: ClothingMatrixRow,
    cell: ClothingMatrixCell
  ): ClothingMatrixAction {
    return {
      row: row,
      cell: cell
    };
  }

  private createCellKey(itemId: string, markerKey: string): string {
    return itemId + '::' + markerKey;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/clothing/clothing-admin-matrix.component.ts